<div>
  <div>
    <div *ngIf="image">
      <dgx-components-picture
        [alt]="image.alt"
        [fit]="'cover'"
        [lazy]="true"
        [position]="image.position"
        [src]="image.src"
      />
    </div>
    <div>
      <div class="title-icon-wrapper">
        <dgx-components-icon
          [icon]="iconName"
          class="reminder-description-icon"
          size="lg"
        />
        <p *ngIf="title" class="typog-body-bold">
          {{ title }}
        </p>
      </div>
      <div class="mt-2">
        <p class="body">{{ description }}</p>
      </div>
    </div>
  </div>
</div>
